/* ==========================================================================
   Changelog Page
   Public page showing release history and new features
   ========================================================================== */

import { useEffect } from 'react'
import { MarketingLayout } from '@/components/layout/MarketingLayout'
import { ChangelogEntry } from '@/components/changelog/ChangelogEntry'
import { useChangelog } from '@/hooks/useChangelog'

export function Changelog() {
  const { versions, markSeen, loading } = useChangelog()

  // Mark changelog as seen when user visits the page
  useEffect(() => {
    if (versions.length > 0) {
      markSeen()
    }
  }, [versions, markSeen])

  return (
    <MarketingLayout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="font-serif text-3xl sm:text-4xl text-[var(--color-charcoal)]">
            What's New
          </h1>
          <p className="mt-2 text-[var(--color-charcoal)]/60 text-sm">
            The latest updates and improvements to the provider portal.
          </p>
        </div>

        {/* Entries */}
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-soft-lavender)] border-t-[var(--color-deep-purple)]" />
          </div>
        ) : versions.length === 0 ? (
          <p className="text-center text-[var(--color-charcoal)]/50 py-12">
            No updates yet. Check back soon!
          </p>
        ) : (
          <div className="space-y-6">
            {versions.map((entry) => (
              <ChangelogEntry key={entry.version} entry={entry} />
            ))}
          </div>
        )}
      </div>
    </MarketingLayout>
  )
}
